export default "__VITE_ASSET__a52ecc94__"